<template>
  <div class="list-page">
    <crumbs title="新闻信息管理" />
    <div class="list-page__querybar">
      <el-row>
        <el-col :span="4">
          <enumerate
            url="/api/news/getindustrytype"
            v-model="queryCondition.industryType"
            placeholder="新闻类别"
          />
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="queryCondition.isRecommend"
            placeholder="是否推荐"
            :clearable="true"
            style="width: 100%"
          >
            <el-option label="是" :value="1"> </el-option>
            <el-option label="否" :value="0"> </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-date-picker
            v-model="queryCondition.publishDate"
            type="daterange"
            :unlink-panels="true"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="10">
          <el-input
            v-model="queryCondition.keyWord"
            clearable
            placeholder="搜索新闻名称"
          >
          </el-input>
        </el-col>
        <el-col class="fn-text-right" :span="2">
          <el-button
            @click="handleSearch"
            size="medium"
            type="success"
            icon="el-icon-search"
            round
            >查询</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div class="list-page__toolbar">
      <el-button
        type="success"
        icon="el-icon-circle-plus"
        @click="redirectByPath(`/admin/activityManage/newsInfo/addition`)"
        >添加
      </el-button>
      <el-button type="warning" icon="el-icon-delete" @click="handleBatchDelete"
        >删除</el-button
      >
    </div>
    <div
      class="list-page__table"
      v-loading="isLoading"
      element-loading-text="拼命加载中"
    >
      <el-table
        :data="queryList"
        @selection-change="handleSelectionChange"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column label="新闻名称" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <a
              href="javascript:;"
              class="clickable-link"
              @click="handleLook(scope.row)"
              >{{ scope.row.title }}</a
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="industryTypeName"
          label="新闻类别"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="isRecommendName"
          label="是否推荐"
          width="90"
          align="center"
        >
        </el-table-column>
        <el-table-column label="发布时间" width="90" align="center">
          <template slot-scope="scope">
            <p>
              {{ scope.row.publishTime.trim().split(/\s+/)[0] }}
            </p>
            <!-- <p>
                {{ scope.row.publishTime.trim().split(/\s+/)[1] }}
              </p> -->
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="warning" @click="handleLook(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fn-text-center mt-20">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="true"
          :total="total"
          :page-size="queryCondition.pageSize"
          :current-page.sync="queryCondition.pageIndex"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "newsList",
  data() {
    return {
      //查询条件
      queryCondition: {
        industryType: "",
        isRecommend: "",
        publishDate: [],
        keyWord: "",
        pageIndex: 1,
        pageSize: 15
      },
      total: 0,
      //是否处于loading状态
      isLoading: true,
      //查询结果
      queryList: [],
      //表格当前的选项（多选）
      multipleSelection: []
    };
  },
  created() {
    this.createQueryCondition();
    this.loadList();
  },
  methods: {
    //出来参数
    processParams() {
      let { keyWord, pageIndex, pageSize, publishDate } = this.queryCondition,
        mixin = {
          industryType: "",
          isRecommend: ""
        },
        [startTime = "", endTime = ""] = publishDate || [];

      Object.keys(mixin).map((item) => {
        mixin[item] =
          this.queryCondition[item] === "" ? -1 : this.queryCondition[item];
      });
      return {
        keyWord,
        pageIndex,
        pageSize,
        ...mixin,
        startTime,
        endTime
      };
    },
    //获取列表
    loadList() {
      //初始化
      // this.queryList = [];
      this.isLoading = true;
      this.$api("activity", "getNewsList", this.processParams()).then((res) => {
        this.isLoading = false;
        this.total = res.count;
        this.queryList = res.dataList;
      });
    },
    //点击后查询
    handleSearch() {
      this.queryCondition.pageIndex = 1;
      this.loadList();
    },
    //表格相关
    //点击选中/取消选中表格选择项
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    //点击编辑
    handleLook(row) {
      const { id } = row;
      this.redirectByPath(
        `/admin/activityManage/newsInfo/modification`,
        {
          id
        },
        this.queryCondition
      );
    },
    //删除
    //点击批量删除
    handleBatchDelete() {
      const idList = this.multipleSelection.map((item) => item.id);
      if (idList.length) {
        this.$confirm("此操作将批量删除所选中的数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.loadDeleteData(idList);
          })
          .catch(() => {});
      }
    },
    //点击一条删除
    handleDelete(row) {
      this.$confirm("此操作将删除当前所选中的数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loadDeleteData([row.id]);
        })
        .catch(() => {});
    },
    loadDeleteData(idList) {
      this.$api("activity", "batchNewsDelete", idList).then((res) => {
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.loadList();
        }
      });
    },
    //点击切换分页触发
    handleCurrentChange() {
      this.loadList();
    }
  }
};
</script>

<style></style>
